import { useState, useEffect } from "react";

import { Button } from "./component.js";
import { DateToFormat } from "../../utils/datetime.js";

// PaidModal lets an admin record (or clear) the date a submitted claim was paid, for
// payment reconciliation on the Claims list. Defaults to today in the browser's timezone.
function PaidModal({ claim, periodLabel, submitting, error, onClose, onConfirm, onClear }) {
  const today = DateToFormat(new Date(), "YYYY-MM-DD");

  const [date, setDate] = useState(claim.paidAt || today);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  const valid = !!date && date <= today;

  return (
    <div
      className="fixed inset-0 z-2000 flex items-center justify-center bg-[#80808094]"
      onClick={submitting ? undefined : onClose}
    >
      <div className="w-full max-w-md px-8">
        <div className="card shadowmore" onClick={(e) => e.stopPropagation()}>
          <div className="card-header">
            <span className="typo-header-3xLarge">Mark Claim Paid</span>
          </div>
          <div className="card-content">
            <div className="d-flex align-items-center mb-3">
              <div className="typo-normal-150 text-muted grow">
                {claim.firstName} {claim.lastName}
              </div>
              <span className="typo-normal-150 text-muted">{periodLabel}</span>
            </div>

            <div className="typo-strong-125 mb-1">Paid date</div>
            <input
              type="date"
              value={date}
              max={today}
              disabled={submitting}
              onChange={(e) => setDate(e.target.value)}
              className="input md typo-body-medium w-full"
            />
            {!valid && (
              <div className="typo-normal-125 text-red-600 mt-1">
                Select a date on or before today.
              </div>
            )}
            {error && (
              <div className="typo-normal-125 text-red-600 mt-1">{error}</div>
            )}

            <div className="d-flex justify-content-between align-items-center mt-4">
              <div>
                {claim.paid && (
                  <Button
                    text="Mark unpaid"
                    color="red"
                    size="sm"
                    muted
                    disabled={submitting}
                    onClick={onClear}
                  />
                )}
              </div>
              <div className="d-flex align-items-center gap-2">
                <Button
                  text="Cancel"
                  color="grey"
                  size="sm"
                  muted
                  disabled={submitting}
                  onClick={onClose}
                />
                <Button
                  text={submitting ? "Saving..." : "Confirm"}
                  color="blue"
                  size="sm"
                  disabled={submitting || !valid}
                  onClick={() => onConfirm(date)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaidModal;
